
import { http } from '@/libs/util'
import util from '@/libs/util'


const { 
    salary_job_sequence_tree_info, 
    salary_job_sequence_save, 
    outsource_contract_title_mapping_save, 
    outsource_contract_title_mapping_query, 
    outsource_contract_title_mapping_delete,
    salary_mapping_save,
    salary_mapping_list,
    salary_mapping_add_title_mapping,
    salary_mapping_remove_title_mapping,
    sales_customer_function_mapping_query,
    sales_customer_function_mapping_change_status,
    sales_customer_function_mapping_save
} = util.api || {}


export function getTreeListApi(params) {
    return http.get(salary_job_sequence_tree_info, params)
}

export function postTreeSaveApi(params) {
    return http.post(salary_job_sequence_save, params)
}

export function getOutsourceContractTitleMappingQueryApi(params) {
    return http.get(outsource_contract_title_mapping_query, params)
}
export function postgetOutsourceContractTitleMappingApi(params) {
    return http.post(outsource_contract_title_mapping_save, params)
}
export function postgetOutsourceContractdeleteApi(params) {
    return http.post(outsource_contract_title_mapping_delete, params)
}

export function postSalaryMappingSaveApi(params) {
    return http.post(salary_mapping_save, params)
}

export function getSalaryMappingListApi(params) {
    return http.get(salary_mapping_list, params)
}

export function postSalaryMappingaddApi(params) {
    return http.post(salary_mapping_add_title_mapping, params)
}

export function postSalaryMappingDelApi(params) {
    return http.post(salary_mapping_remove_title_mapping, params)
}

export function getSalaryCustomerFunctionMappingListApi(params) {
    return http.get(sales_customer_function_mapping_query, params)
}

// sales_customer_function_mapping_change_status
export function postSalaryCustomerFunctionMappingStatusApi(params) {
    return http.post(sales_customer_function_mapping_change_status, params)
}

export function postSalaryCustomerFunctionMappingSaveApi(params) {
    return http.post(sales_customer_function_mapping_save, params) 
}
// sales_customer_function_mapping_save